import React from 'react';
import { Poster } from '../models/poster';

interface VoteTableProps {
    posters: Poster[];
    isVoteSaving?: boolean;
    currentMemberId: number;
    hasPosterRightToVote: (poster: Poster) => boolean;
    saveVote: (vote: string) => void;
    VoteValue: { keep: string; remove: string };
}

const VoteTable: React.FC<VoteTableProps> = ({
    posters,
    isVoteSaving,
    currentMemberId,
    hasPosterRightToVote,
    saveVote,
    VoteValue,
}) => (
    <div className="intianl-removal-btn-div" onClick={() => {}}>
        <div className="vote-detail">
            <div className="vote-row">
                <div className="member">
                    <h6>Member</h6>
                </div>
                <div className="vote-to-remove">
                    <h6>Vote to Remove</h6>
                </div>
                <div className="vote-to-remove Keep">
                    <h6>Vote to Keep</h6>
                </div>
            </div>
            {posters.map((poster: Poster, i: number) => (
                <div key={i}>
                    {hasPosterRightToVote(poster) ? (
                        <div
                            className="vote-row"
                            onChangeCapture={(event: any) =>
                                saveVote(event.target.value)
                            }
                        >
                            <div className="member">
                                <label>{poster.fullName}</label>
                            </div>
                            <div className="vote-to-remove">
                                <div className="check">
                                    <input
                                        type="radio"
                                        id={`vote-remove-${poster.id}`}
                                        name={`vote-${poster.id}`}
                                        disabled={isVoteSaving}
                                        value={VoteValue.remove}
                                        readOnly={true}
                                        checked={poster.vote}
                                    />
                                    {poster.id === currentMemberId ? (
                                        <label
                                            htmlFor={`vote-remove-${poster.id}`}
                                            id="kenCole"
                                            className="label-input"
                                        ></label>
                                    ) : (
                                        <label className="label-input"></label>
                                    )}
                                </div>
                            </div>
                            <div className="vote-to-remove Keep">
                                <div className="check">
                                    <input
                                        type="radio"
                                        id={`vote-keep-${poster.id}`}
                                        name={`vote-${poster.id}`}
                                        disabled={isVoteSaving}
                                        value={VoteValue.keep}
                                        readOnly={true}
                                        checked={poster.vote === false}
                                    />
                                    {poster.id === currentMemberId ? (
                                        <label
                                            htmlFor={`vote-keep-${poster.id}`}
                                            id="kenCole"
                                            className="label-input"
                                        ></label>
                                    ) : (
                                        <label className="label-input"></label>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        []
                    )}
                </div>
            ))}
        </div>
    </div>
);

export default VoteTable;
